module.exports = __webpack_public_path__ + "static/img/tky-kcbg3-nor@2x.548a7b80.png";